import React, {useEffect, useRef, useState} from 'react';
import {Button} from "primereact/button";
import {UserService} from "../../service/UserService";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputSwitch} from "primereact/inputswitch";
import {formValid, getKeyValue, toTitleCase} from "../../utils/Utils";
import {toDateTimeString, toRelativeTimeString, isOlderThanDays} from "../../utils/TimeUtil";
import {Loading} from "../../utils/InlineComponents";
import {Menu} from "primereact/menu";
import {OverlayPanel} from "primereact/overlaypanel";
import {tagList} from "../../utils/Constants";
import {Message} from "primereact/message";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import {Password} from "primereact/password";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import UpdateUser from "./UpdateUser";
import UserNotes from "./UserNotes";
import UserIntegrations, {INTEGRATIONS} from "./UserIntegrations";
import {AccountService} from "../../service/AccountService";
import {Dropdown} from "primereact/dropdown";
import {AppContext} from "../../HomePage";
import {PricingPlanService} from "../../service/PricingPlanService";
import {InputNumber} from "primereact/inputnumber";
import PricingPlanForm from "./PricingPlanForm";
import AdminPageHeader from "./AdminPageHeader";
import queryString from "query-string";


// Admin-started trial length: default and upper bound (the API refuses more).
const DEFAULT_TRIAL_DAYS = 14;
const MAX_TRIAL_DAYS = 90;

// A charge preview pins the instant exchange rate; it may only be confirmed
// within this window so a stale rate is never charged.
const CHARGE_PREVIEW_TTL_MS = 60000;
const CHARGE_PREVIEW_TTL_SECONDS = CHARGE_PREVIEW_TTL_MS / 1000;
const CHARGE_COUNTDOWN_RADIUS = 25;
const CHARGE_COUNTDOWN_CIRCUMFERENCE = 2 * Math.PI * CHARGE_COUNTDOWN_RADIUS;

const User = (props) => {

    const {t, toast, setError, navigate} = React.useContext(AppContext);
    let dtUsers = useRef(null);

    const [showEditModal, setShowEditModal] = useState(false);
    const [notesUser, setNotesUser] = useState(null);
    const [menuUser, setMenuUser] = useState(null);
    const [dialogUser, setDialogUser] = useState(null);
    const [tagsUser, setTagsUser] = useState(null);
    const tagsPanel = useRef(null);
    const [integrationsUser, setIntegrationsUser] = useState(null);
    const rowMenu = useRef(null);
    const stickyHeaderRef = useRef(null);
    const [passwordDialogVisible, setPasswordDialogVisible] = useState(false);
    const [chargeDialogVisible, setChargeDialogVisible] = useState(false);
    const [trialDialogVisible, setTrialDialogVisible] = useState(false);
    const [trialDays, setTrialDays] = useState(DEFAULT_TRIAL_DAYS);
    const [trialLoading, setTrialLoading] = useState(false);
    const [subscriptionDialogVisible, setSubscriptionDialogVisible] = useState(false);
    const [subscriptionHistoryDialogVisible, setSubscriptionHistoryDialogVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [resolvingCountries, setResolvingCountries] = useState(false);
    const [selectedUserType, setSelectedUserType] = useState("all");
    const [specialPlanDialogVisible, setSpecialPlanDialogVisible] = useState(false);
    const [specialPlan, setSpecialPlan] = useState(null);

    const [users, setUsers] = useState([]);
    const [forceRefresh, setForceRefresh] = useState(0);
    const [standardPricingPlans, setStandardPricingPlans] = useState([]);
    const [selectedStandardPricingPlan, setSelectedStandardPricingPlan] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [editedSubscription, setEditedSubscription] = useState({
        plan_price:"",
        start_at:"",
        finish_at:"",
        total_product_count:"",
        daily_price_check_count:"",
        manuel_price_check_count:"",
        instant_price_check_enabled:"",
        sale_history_enabled:"",
        competitor_suggestion_enabled:"",
        dynamic_pricing_enabled:"",
        is_paid:"",
        is_canceled:"",
        product_variant_tracking_enabled:"",
        daily_notification_enabled:"",
        price_history_enabled:"",
        stock_availability_monitoring_enabled:"",
        product_cost_monitoring_enabled:"",
        instant_notification_enabled:"",
        api_enabled:"",

    });

    const [filter, setFilter] = useState(() => {
        // The engagement mails link straight to /#/user?email=..., so the admin
        // lands on the right row instead of searching for it. HashRouter: the
        // query string lives INSIDE the hash, so window.location.search is
        // empty here -- read it off window.location.hash, exactly as
        // Product.js::setFiltersFromQueryString does.
        const params = queryString.parse((window.location.hash.split('?')[1]) || '');
        return params.email || '';
    });
    const [change_password, setChange_password] = useState({
        user_id:"",
        new_password:""
    });

    const [charge, setCharge] = useState({
        user_id:"",
        amount: 0,
        vat_rate: null,
        exchange_rate: null
    });
    const [chargePreview, setChargePreview] = useState(null);
    const [chargeLoading, setChargeLoading] = useState(false);
    const [chargePreviewSecondsLeft, setChargePreviewSecondsLeft] = useState(null);
    // Charge currency reported by the opening preview call ('TRY' or 'USD'):
    // non-TR users whose card starts with 3 (Amex etc.) are charged in TRY.
    const [chargeCurrency, setChargeCurrency] = useState(null);

    const [pricingPlans, setPricingPlans] = useState([]);
    const [currentPlan, setCurrentPlan] = useState(null);
    const [subscriptionHistory, setSubscriptionHistory] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [engagementDetails, setEngagementDetails] = useState({});
    const [formErrors, setFormErrors] = useState({
        new_password:"",
        plan_price:"",
        start_at:"",
        finish_at:"",
        total_product_count:"",
        daily_price_check_count:"",
        manuel_price_check_count:"",
        instant_price_check_enabled:"",
        sale_history_enabled:"",
        competitor_suggestion_enabled:"",
        dynamic_pricing_enabled:"",
        is_paid:"",
        is_canceled:""
    });

    const userService = new UserService();
    const accountService = new AccountService();
    const pricingPlanService = new PricingPlanService();

    useEffect(()=>{
        getUsers(false)
    }, [forceRefresh]);

    useEffect(() => {
        if (!chargePreview)
            return;
        // Deadline-based countdown so a throttled background tab still
        // expires (and displays) correctly on the next tick.
        const deadline = Date.now() + CHARGE_PREVIEW_TTL_MS;
        setChargePreviewSecondsLeft(Math.round(CHARGE_PREVIEW_TTL_MS / 1000));
        const timer = setInterval(() => {
            const secondsLeft = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
            setChargePreviewSecondsLeft(secondsLeft);
            if (secondsLeft <= 0) {
                setChargePreview(null);
                toast.current.show({severity: 'warn', summary: t('actions.charge_user'), detail: t('user.charge_preview_expired')});
            }
        }, 1000);
        return () => clearInterval(timer);
    }, [chargePreview]);

    // Expose the sticky page header height so the table header can stick right below it.
    useEffect(() => {
        const updateStickyOffset = () => {
            if (stickyHeaderRef.current)
                document.documentElement.style.setProperty('--users-header-height', stickyHeaderRef.current.offsetHeight + 'px');
        };
        updateStickyOffset();
        window.addEventListener('resize', updateStickyOffset);
        return () => window.removeEventListener('resize', updateStickyOffset);
    }, [users, loading]);

    const resolveSignupCountries = () => {
        setResolvingCountries(true);
        userService.resolveSignupCountries().then(result => {
            toast.current.show({
                severity: 'success',
                summary: t('actions.resolve_signup_countries'),
                detail: t('user.signup_countries_resolved', {resolved: result.resolved, remaining: result.remaining})
            });
            if (result.resolved > 0) {
                setForceRefresh(forceRefresh + 1);
            }
        }).catch(error => {
            setError(error);
            setError(null);
        }).finally(() => setResolvingCountries(false));
    };

    // A cached list is only good for an early paint when it is the admin
    // list shape (with subscriptions); other screens cache the same key
    // without them.
    const cachedUsers = (all_user) => {
        const cached = userService.getCachedUsers();
        if (!Array.isArray(cached) || cached.length === 0 || !('subscription' in cached[0]) || !('connected_integrations' in cached[0]))
            return null;
        return all_user ? cached : cached.filter(user => user.is_visible !== false);
    };

    const getUsers = (all_user) => {
        // Paint the cached list right away and refresh it in the background;
        // the spinner only shows when there is nothing to paint yet.
        const cached = cachedUsers(all_user);
        if (cached) {
            setUsers(cached);
            setRefreshing(true);
        } else
            setLoading(true);

        userService.getUsers(true, true, all_user).then(users=>{
            setUsers(users);
        }).catch(error =>{
            setError(error);
            setError(null);
        }).finally(() => {
            setLoading(false);
            setRefreshing(false);
        });

        pricingPlanService.getStandardPricingPlans().then(standardPricingPlans=>{
            setStandardPricingPlans(standardPricingPlans.map(item => ({label: item.name, value: item.id})));
        }).catch(error =>{
            setError(error);
            setError(null);
        });

        return () => {
            toast.current.clear();
        }
    }

    // List rows only carry scalar fields (see AdminUserRowSerializer), so
    // anything that edits or PUTs a user starts from the full record.
    const withFullUser = (rowData, callback) => {
        userService.getUser(rowData.id).then(callback).catch(error => {
            setError(error);
            setError(null);
        });
    };

    const connectedIntegrations = (apiIntegration) =>
        Object.keys(apiIntegration || {}).filter(key => apiIntegration[key]).sort();

    const createdAtTemplate = (rowData) => <span>{toDateTimeString(rowData.created_at)}</span>;

    // A team member's login also stamps the owner's last_login_at, so name
    // who it was when the latest sign-in was not the owner's.
    const last_login_atTemplate = (rowData) => {
        const identity = rowData.last_login_identity;
        return <div>
            <span title={toDateTimeString(rowData.last_login_at)}
                  className={isOlderThanDays(rowData.last_login_at, 30) ? 'stale-login' : ''}>
                {toRelativeTimeString(rowData.last_login_at)}
            </span>
            {identity && !identity.is_owner &&
            <div className="user-info-team" title={`${identity.email} · ${toDateTimeString(identity.last_login_at)}`}>
                {t('user.last_login_by', {name: identity.name || identity.email})}
            </div>}
        </div>;
    };

    const teamMemberLabel = (member) => member.name || member.email;

    const noteTemplate = (rowData) => {
        const sortedNotes = [...(rowData.notes || [])].sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
        const noteCount = sortedNotes.length + (rowData.note ? 1 : 0);
        const latestNote = sortedNotes[0] || (rowData.note ? {text: rowData.note} : null);
        return <div className="note-cell" onClick={() => setNotesUser(rowData)}>
            {latestNote
                ? <>
                    <div className="note-cell-meta">
                        {latestNote.created_at ? toDateTimeString(latestNote.created_at) : t('user.legacy_note')}
                        {noteCount > 1 ? ` (+${noteCount - 1})` : ''}
                    </div>
                    <div className="note-cell-text">{latestNote.text}</div>
                </>
                : <span className="note-cell-add"><i className="pi pi-plus" style={{fontSize: '0.85em'}}/> {t('user.add_note')}</span>}
        </div>;
    };

    const integrationsTemplate = (rowData) => {
        const shopifyAppShop = rowData.shopify_shop;
        const connectedKeys = INTEGRATIONS.filter(integration => (rowData.connected_integrations || []).includes(integration.key))
            .map(integration => integration.key)
            .sort((a, b) => t('user.api.' + a).localeCompare(t('user.api.' + b), undefined, {sensitivity: 'base'}));
        return <div className="integration-cell" onClick={() => withFullUser(rowData, setIntegrationsUser)}>
            {(connectedKeys.length > 0 || shopifyAppShop)
                ? <div className="user-tags">
                    {shopifyAppShop && <span className="user-tag shopify" title={shopifyAppShop}>{t('user.api.shopify_app')}</span>}
                    {connectedKeys.map(key => <span key={key} className="user-tag">{t('user.api.' + key)}</span>)}
                </div>
                : <span className="note-cell-add"><i className="pi pi-plus" style={{fontSize: '0.85em'}}/> {t('user.api.add_integration')}</span>}
        </div>;
    };

    const persistIntegrations = (updatedUser) => {
        return userService.updateUser(updatedUser).then(() => {
            const index = users.findIndex(u => u.id === updatedUser.id);
            if (index >= 0) {
                users[index] = {...users[index], connected_integrations: connectedIntegrations(updatedUser.api_integration)};
                setUsers([...users]);
            }
            setIntegrationsUser(updatedUser);
            toast.current.show({severity: 'success', summary: t('user.integrations'), detail: t('message_detail.successful')});
        }).catch(error => {
            setError(error);
            setError(null);
            throw error;
        });
    };

    const notesChanged = (userId, response) => {
        const index = users.findIndex(u => u.id === userId);
        if (index >= 0) {
            users[index] = {...users[index], notes: response.notes, note: response.note};
            setUsers([...users]);
        }
    };

    const userInfoTemplate = (rowData) => {
        return <div className="user-info">
            <div className="user-info-name">{rowData.full_name}</div>
            <div className="user-info-email">{rowData.email}</div>
            {rowData.usage_type && rowData.usage_type !== 'seller' && <div className="user-info-type">{rowData.usage_type}</div>}
            {teamSummary(rowData)}
        </div>;
    };

    // Team members arrive most recent sign-in first (see match_team_logins).
    const teamSummary = (rowData) => {
        const members = rowData.team_members || [];
        if (members.length === 0)
            return null;
        const latest = members[0].last_login_at ? members[0] : null;
        const title = members.map(member => `${teamMemberLabel(member)}: ${member.last_login_at
            ? toDateTimeString(member.last_login_at) : t('user.team_never_signed_in')}`).join('\n');
        return <div className="user-info-team" title={title}>
            <i className="pi pi-users"/> {t('user.team_count', {count: members.length})}
            {latest
                ? ` · ${t('user.team_last', {name: teamMemberLabel(latest), when: toRelativeTimeString(latest.last_login_at)})}`
                : ` · ${t('user.team_never')}`}
        </div>;
    };

    const is_manufacturerTemplate = (rowData) => {
        return <div>{rowData.is_manufacturer === null ? t('user.market_research') : rowData.is_manufacturer === true ? t('user.manufacturer') : t('user.seller')}</div>;
    };

    const SPECIAL_TAGS = ['Alabilir', 'Eski Müşteri', 'Hesap Kurulacak'];

    const PLAN_KEYS = ['basic', 'professional', 'business', 'premium', 'special'];

    // The plan a subscription is on, as a lower-case key. Web plans carry it
    // in `type`; the Shopify plans are all stored with type 'paid' and carry
    // the plan (Basic / Professional / Business / Premium) in `name`.
    const subscriptionPlanKey = (subscription) => {
        if (!subscription || !subscription.type)
            return null;
        if (subscription.type === 'paid')
            return (subscription.name || '').toLowerCase();
        return subscription.type;
    };

    const subscriptionCategoryTag = (subscription) => {
        if (!subscription || !subscription.type)
            return null;
        if (subscription.type === 'trial') {
            const expired = Date.parse(subscription.finish_at) < new Date();
            return expired ? {label: 'Ex-Trial', className: 'exTrial'} : {label: 'Trial', className: 'trial'};
        }
        const planKey = subscriptionPlanKey(subscription);
        if (!subscription.is_canceled && PLAN_KEYS.includes(planKey)) {
            // A paid period that ran out without a renewal (Shopify stores
            // that stopped paying; web accounts always get a renewal row).
            if (subscription.finish_at && Date.parse(subscription.finish_at) < new Date())
                return {label: 'Expired', className: 'expired'};
            return {label: toTitleCase(planKey), className: planKey};
        }
        return null;
    };

    // Derived from the backend engagement summary and rendered next to the
    // subscription chips. Deliberately NOT written into rowData.tags: editing
    // tags PUTs the whole array, so an auto-written tag would be dropped the
    // moment an admin touches the tag panel.
    const ENGAGEMENT_CHIPS = {
        engaged: {labelKey: 'user.engagement_engaged', className: 'engaged'},
        low: {labelKey: 'user.engagement_low', className: 'lowEngagement'},
        dormant: {labelKey: 'user.engagement_dormant', className: 'dormant'}
    };

    const engagementTooltip = (engagement) => {
        if (!engagement || !engagement.self_total)
            return t('user.engagement_none');
        // self_counts carries the real per-kind totals. engagement.milestones is
        // a list of milestone KEYS, so counting it would only ever say "1".
        const counts = engagement.self_counts || {};
        return t('user.engagement_self_summary', {
            campaign: counts.campaign || 0,
            product: counts.product || 0,
            url: counts.competitor_url || 0
        });
    };

    const engagementTag = (rowData) => {
        const engagement = rowData.engagement;
        if (!engagement)
            return null;
        if (engagement.level && ENGAGEMENT_CHIPS[engagement.level]) {
            const chip = ENGAGEMENT_CHIPS[engagement.level];
            return {label: t(chip.labelKey), className: chip.className,
                    title: engagementTooltip(engagement)};
        }
        // Lapsed cohorts get a chip only when they actually came back.
        if (engagement.returned)
            return {label: t('user.engagement_returned'), className: 'returned',
                    title: engagementTooltip(engagement)};
        return null;
    };

    const userCategoryTags = (rowData, isShopify) => {
        const categories = [];

        if (rowData.is_admin)
            categories.push({label: 'Admin', className: 'admin'});

        // Shopify users get their plan shown on the Shopify tag instead.
        if (!isShopify) {
            const subscriptionTag = subscriptionCategoryTag(rowData.subscription);
            if (subscriptionTag)
                categories.push(subscriptionTag);
        }

        if (rowData.tags.includes('Alabilir'))
            categories.push({label: 'Potential', className: 'potential'});
        if (rowData.tags.includes('Eski Müşteri'))
            categories.push({label: 'Former', className: 'former'});
        if (rowData.tags.includes('Hesap Kurulacak'))
            categories.push({label: 'Account Setup', className: 'accountSetup'});

        const engagement = engagementTag(rowData);
        if (engagement)
            categories.push(engagement);

        return categories;
    };

    const tagsTemplate = (rowData) => {
        const shopifyShop = rowData.shopify_shop;
        const subscriptionTag = subscriptionCategoryTag(rowData.subscription);
        const shopifyLabel = 'Shopify' + (subscriptionTag ? ' ' + subscriptionTag.label : '');
        return <div className="user-tags">
            {userCategoryTags(rowData, !!shopifyShop).map(tag => <span key={tag.label} className={`user-tag ${tag.className}`} title={tag.title}>{tag.label}</span>)}
            {shopifyShop && <span className="user-tag shopify" title={shopifyShop}><i className="pi pi-shopping-cart" style={{fontSize: '0.85em'}}/> {shopifyLabel}</span>}
            {rowData.signup_country && <span className="user-tag country" title={rowData.signup_ip}>{rowData.signup_country}</span>}
            {!rowData.signup_country && rowData.signup_ip && <span className="user-tag noCountry" title={rowData.signup_ip}>no_country</span>}
            {rowData.tags.filter(tag => !SPECIAL_TAGS.includes(tag)).map(tag => <span key={tag} className="user-tag">{tag}</span>)}
            <i className="pi pi-pencil tags-edit" title={t('actions.edit')} onClick={(e) => {
                setTagsUser(rowData);
                tagsPanel.current.toggle(e);
            }}/>
        </div>;
    };

    const toggleTag = (tag, checked) => {
        const tags = checked ? [...tagsUser.tags, tag] : tagsUser.tags.filter(existing => existing !== tag);
        const updatedUser = {...tagsUser, tags};
        setTagsUser(updatedUser);
        // The update endpoint rewrites every field it is sent, so PUT the full
        // record with only the tags changed, never the slim list row.
        userService.getUser(updatedUser.id).then(fullUser => userService.updateUser({...fullUser, tags})).then(() => {
            const index = users.findIndex(u => u.id === updatedUser.id);
            if (index >= 0) {
                users[index] = {...users[index], tags};
                setUsers([...users]);
            }
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    // const is_lockedTemplate = (rowData) => {
    //     return <div>
    //         <InputSwitch checked={rowData.is_locked} onChange={() => changeIsLocked(rowData)} tooltip={rowData.is_locked ? t('actions.unlock') : t('actions.lock') } />
    //     </div>;
    // };

    // const is_activeTemplate = (rowData) => {
    //     return <div>
    //         <InputSwitch checked={rowData.is_active} onChange={() => changeIsActive(rowData)} tooltip={rowData.is_active ? t('actions.deactivate') : t('actions.activate') } />
    //     </div>;
    // };

    const changeIsLocked = (rowData) => {
        userService.lock_unlock(rowData.id, rowData.is_locked).then(updated_user => {
            const index = users.findIndex(user => user.id === updated_user.id);
            users[index].is_locked = !rowData.is_locked;
            setUsers([...users]);

            toast.current.show({severity: 'success', summary: updated_user.is_locked ? t('actions.locked') : t('actions.unlocked'), detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });

    };

    const changeIsActive = (rowData) => {
        userService.active_deactivate(rowData.id, rowData.is_active).then(updated_user => {
            const index = users.findIndex(user => user.id === updated_user.id);
            users[index].is_active = !rowData.is_active;
            setUsers([...users]);

            toast.current.show({severity: 'success', summary: updated_user.is_active ? t('actions.activate') : t('actions.deactivate'), detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });

    };

    const changeIsApproved = (rowData) => {
        userService.approve(rowData.id).then(updated_user => {
            const index = users.findIndex(user => user.id === updated_user.id);
            // The response is a full user without the list-only fields
            // (subscription, engagement, derived ones): merge, do not replace.
            users[index] = {...users[index], is_approved: updated_user.is_approved};
            setUsers([...users]);

            toast.current.show({severity: 'success', summary: t('actions.approved'), detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });

    };

    const onChange = (e) => {
        const { key, value } = getKeyValue(e);

        if(key === "new_password")
        {
            setFormErrors({...formErrors, [key]: checkPasswordError(key, value)});
            setChange_password({...change_password, [key] : value});
        }
        else if(key === "amount" || key === "vat_rate" || key === "exchange_rate")
        {
            setCharge({...charge, [key] : value});
        }
        else {
            setFormErrors({...formErrors, [key]: checkSubscriptionError(key, value)});
            setEditedSubscription({...editedSubscription, [key] : value});
        }

    };

    const userDisplayName = (user) => {
        if (!user)
            return '';
        const fullName = `${toTitleCase(user.first_name || '')} ${toTitleCase(user.last_name || '')}`.trim();
        return fullName || user.email;
    };

    const dialogHeader = (title) => dialogUser ? `${title} — ${userDisplayName(dialogUser)}` : title;

    const showPasswordDialog = (rowData) => {
        setDialogUser(rowData);
        setChange_password({user_id: rowData.id, new_password:""});
        setPasswordDialogVisible(true);
    };

    const showChargingDialog = (rowData) => {
        setDialogUser(rowData);
        setCharge({user_id: rowData.id, amount: 0, vat_rate: rowData.country === 'TR' ? 20 : 0, exchange_rate: null});
        setChargePreview(null);
        setChargeCurrency(null);
        setChargeDialogVisible(true);
        // Prefill the instant exchange rate (a zero-amount preview returns the
        // rate the user would be charged with) so the admin can adjust it.
        accountService.previewCharge(rowData.id, 0, null, null).then(preview => {
            setChargeCurrency(preview.currency);
            setCharge(prev => prev.exchange_rate === null ? {...prev, exchange_rate: preview.exchange_rate} : prev);
        }).catch(error => {
            setError(error);
            setError(null);
        });
    };

    // The row's subscription is the latest one by finish_at; a trial may only be
    // started when it is cancelled or already over (the API checks every row).
    const hasActiveSubscription = (user) => {
        const subscription = user.subscription;
        if (!subscription || subscription.is_canceled || !subscription.finish_at)
            return false;
        return subscription.finish_at >= toIsoDate(new Date());
    };

    const toIsoDate = (date) => {
        const pad = (value) => String(value).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    };

    const trialFinishDate = (days) => {
        const date = new Date();
        date.setDate(date.getDate() + (days || 0));
        return toIsoDate(date);
    };

    const showTrialDialog = (rowData) => {
        setDialogUser(rowData);
        setTrialDays(DEFAULT_TRIAL_DAYS);
        setTrialDialogVisible(true);
    };

    const startTrial = () => {
        setTrialLoading(true);
        accountService.startTrial(dialogUser.id, trialDays).then(subscription => {
            setUsers(users.map(user => user.id === dialogUser.id ? {...user, subscription: subscription} : user));
            toast.current.show({severity: 'success', summary: t('actions.start_trial'), detail: t('message_detail.successful')});
            setTrialDialogVisible(false);
        }).catch(error => {
            setError(error);
            setError(null);
        }).finally(() => setTrialLoading(false));
    };

    const changePassword = () => {

        checkAllPasswordErrors(change_password).then(formErrors=> {
            if (formValid(formErrors)) {
                userService.changeUserPassword(change_password.user_id, change_password.new_password).then(()=>{
                    toast.current.show({severity: 'success', summary: t('actions.change_password'), detail: t('message_detail.successful')});
                    setPasswordDialogVisible(false);
                }).catch(error =>{
                    setError(error);
                    setError(null);
                });
            }
            else
                setFormErrors(formErrors);
        });
    };

    const previewCharge = () => {
        setChargeLoading(true);
        accountService.previewCharge(charge.user_id, charge.amount, charge.vat_rate, charge.exchange_rate).then(preview => {
            setChargePreview(preview);
        }).catch(error =>{
            setError(error);
            setError(null);
        }).finally(() => setChargeLoading(false));
    };

    const chargeUser = () => {
        setChargeLoading(true);
        // Charge with the values the admin approved on the preview: the instant
        // exchange rate is pinned there, so a rate move between preview and
        // confirm cannot change the charged amount.
        const vat_rate = chargePreview ? chargePreview.vat_rate : charge.vat_rate;
        const exchange_rate = chargePreview ? chargePreview.exchange_rate : charge.exchange_rate;
        accountService.chargeUser(charge.user_id, charge.amount, vat_rate, exchange_rate).then(()=>{
            toast.current.show({severity: 'success', summary: t('actions.charge_user'), detail: t('message_detail.successful')});
            setChargeDialogVisible(false);
            setChargePreview(null);
        }).catch(error =>{
            setError(error);
            setError(null);
        }).finally(() => setChargeLoading(false));
    };

    const checkPasswordError = (name, value) => {
        let errorText = "";

        if (name === "new_password") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }
        return errorText;
    };

    const checkAllPasswordErrors = async (change_password) => {
        let tempErrors = {...formErrors};
        Object.entries(change_password).forEach(([key, value]) => {
            tempErrors[key] = checkPasswordError(key, value);
        });

        return tempErrors;
    };

    const showSubscriptionDialog = (rowData) => {
        setDialogUser(rowData);
        if (rowData.subscription){
            // The list row carries a slim subscription (SubscriptionRowSerializer);
            // the dialog edits and PUTs the full record.
            Promise.all([
                userService.getSubscriptionHistory(rowData.id),
                pricingPlanService.getPricingPlans()
            ]).then(([subscriptions, pricingPlans]) => {
                const subscription = subscriptions.find(item => item.id === rowData.subscription.id);
                if (!subscription) {
                    toast.current.show({severity: 'warn', summary: t('subscription.user_has_no_subscription'), detail: t('message_detail.failed')});
                    return;
                }
                setEditedSubscription(subscription);
                setPricingPlans(pricingPlans)
                let currentPlan = pricingPlans.filter(plan => plan.id === subscription.pricing_plan_id)[0]
                setCurrentPlan(currentPlan)
                if (currentPlan) {
                    currentPlan.additional_features.forEach(item => {
                        let additional_feature = (subscription.additional_features || []).filter(innerItem => innerItem.name === item.name)[0]
                        if (additional_feature) {
                            item.price = additional_feature.price
                            item.is_selected = true
                        }
                    })
                }
                setSubscriptionDialogVisible(true);
            }).catch(error => {
                setError(error);
                setError(null);
            });
        }
        else
            toast.current.show({severity: 'warn', summary: t('subscription.user_has_no_subscription'), detail: t('message_detail.failed')});
    };

    const convertSpecialSubscription = () => {
        userService.convertSpecialSubscription(editedSubscription, selectedStandardPricingPlan).then(updatedSubscription=>{
            let index = users.findIndex(user => user.id === updatedSubscription.user_id);
            users[index].subscription = updatedSubscription;
            setUsers(users);
            toast.current.show({severity: 'success', summary: t('actions.update_subscription'), detail: t('message_detail.successful')});
            setSubscriptionDialogVisible(false);
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const updateSubscription = () => {
        checkAllSubscriptionErrors(editedSubscription).then(formErrors=> {
            if (formValid(formErrors)) {
                if (currentPlan) {
                    editedSubscription.additional_features = currentPlan.additional_features.filter(additional_feature => additional_feature.is_selected)
                }
                userService.updateSubscription(editedSubscription).then(updatedSubscription=>{

                    let index = users.findIndex(user => user.id === updatedSubscription.user_id);
                    users[index].subscription = updatedSubscription;
                    setUsers(users);

                    toast.current.show({severity: 'success', summary: t('actions.update_subscription'), detail: t('message_detail.successful')});
                    setSubscriptionDialogVisible(false);
                }).catch(error =>{
                    setError(error);
                    setError(null);
                });

            }
            else
                setFormErrors(formErrors);
        });
    }

    const checkSubscriptionError = (name, value) => {
        let errorText = "";

        if (name === "plan_price") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }
        else if (name === "start_at") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }
        else if (name === "finish_at") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }
        else if (name === "total_product_count") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }
        else if (name === "daily_price_check_count") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }
        else if (name === "manuel_price_check_count") {
            errorText =  value === "" ? t('validations.invalid_value') : "";
        }

        return errorText;
    };

    const checkAllSubscriptionErrors = async (editedSubscription) => {
        let tempErrors = {...formErrors};
        Object.entries(editedSubscription).forEach(([key, value]) => {
            tempErrors[key] = checkSubscriptionError(key, value);
        });

        return tempErrors;
    };

    const showSubscriptionHistory = (e, rowData) => {
        setDialogUser(rowData);
        userService.getSubscriptionHistory(rowData.id).then(subscriptionHistory=>{

            setSubscriptionHistory(subscriptionHistory);
            setSubscriptionHistoryDialogVisible(true);

        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const showSpecialPlan = (e, rowData) => {
        setDialogUser(rowData);
        userService.getSpecialPlan(rowData.id).then(specialPlan=>{
            setSpecialPlan(specialPlan);
            setSpecialPlanDialogVisible(true);
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const impersonate = (rowData) => {
        accountService.impersonate(rowData.id).then(data => {
            navigate('campaign');
            window.location.reload(false);
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const addSpecialPlan = () => {
        pricingPlanService.addPricingPlan(specialPlan).then(addedPlan => {
            setSpecialPlan(null);
            setSpecialPlanDialogVisible(false);
            toast.current.show({severity: 'success', summary: t('actions.add_special_plan'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const deleteSpecialPlan = () => {
        pricingPlanService.deletePricingPlan(specialPlan.id).then(data => {
            setSpecialPlan(null);
            setSpecialPlanDialogVisible(false);
            toast.current.show({severity: 'success', summary: t('actions.delete_special_plan'), detail: t('message_detail.successful')});
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    };

    const confirmDelete = (rowData) => {

        toast.current.show({ severity: 'warn', sticky: true,  closable: false, content: (
                <div className="p-flex p-flex-column" style={{flex: '1'}}>
                    <div className="p-text-center">
                        <i className="pi pi-exclamation-triangle" style={{fontSize: '3rem'}}/>

                        <p>{t('dialogs.confirm_user_delete')}</p>

                        <h5>{t('dialogs.confirm_user_delete_msg0')}<b>{(rowData ? rowData.email + "(" + rowData.first_name + " " + rowData.last_name + ")" : "")}</b></h5>

                        <p>{t('dialogs.confirm_user_delete_msg1')}</p>

                        <p>{t('dialogs.confirm_user_delete_msg2')}</p>
                        <br/>
                    </div>
                    <div className="p-grid p-fluid">
                        <div className="p-col-6">
                            <Button label={t('yes_no.yes')} icon="pi pi-check" className="p-button-success" onClick={() => {
                                deleteUser(rowData);
                                toast.current.clear();
                            }} />
                        </div>
                        <div className="p-col-6">
                            <Button label={t('yes_no.no')} icon="pi pi-times" className="p-button-secondary" onClick={() => {
                                toast.current.clear();
                            }} />
                        </div>
                    </div>
                </div>
            ) });
    };



    const deleteUser = (rowData) => {
        userService.deleteUser(rowData.id).then(message=>{
            let filteredUsers = users.filter(user => user.id !== rowData.id);
            setUsers(filteredUsers);
            toast.current.show({severity: 'success', summary: message, detail: t('message_detail.successful')})
        }).catch(error =>{
            setError(error);
            setError(null);
        });
    }

    const copyUserId = (id) => {
        navigator.clipboard.writeText(id);
        toast.current.show({severity: 'success', summary: t('actions.copied'), detail: id, life: 1500});
    };

    const detailTemplate = (rowData) => {
        const shopifyShop = rowData.shopify_shop;
        const subscription = rowData.subscription;
        return <div className="user-detail">
            <div className="user-detail-group">
                <div className="user-detail-title">{t('user.account_details')}</div>
                <div className="user-detail-row">
                    <span className="user-detail-label">Id</span>
                    <span className="user-detail-value">
                        {rowData.id}
                        <i className="pi pi-copy user-detail-copy" title={t('actions.copied')} onClick={() => copyUserId(rowData.id)}/>
                    </span>
                </div>
                <div className="user-detail-row">
                    <span className="user-detail-label">{t('user.date_joined')}</span>
                    <span className="user-detail-value">{toDateTimeString(rowData.date_joined)}</span>
                </div>
                {shopifyShop &&
                <div className="user-detail-row">
                    <span className="user-detail-label">Shopify</span>
                    <span className="user-detail-value">
                        <a href={`https://${shopifyShop}/admin`} target="_blank" rel="noopener noreferrer">{shopifyShop}</a>
                    </span>
                </div>}
            </div>
            {(rowData.team_members || []).length > 0 &&
            <div className="user-detail-group">
                <div className="user-detail-title">{t('user.team_members')}</div>
                {rowData.team_members.map(member =>
                    <div className="user-detail-row" key={member.email}>
                        <span className="user-detail-label" title={member.email}>{teamMemberLabel(member)}</span>
                        <span className="user-detail-value">
                            {member.name && <span className="user-info-email">{member.email} · </span>}
                            {member.last_login_at
                                ? <span title={toDateTimeString(member.last_login_at)}
                                        className={isOlderThanDays(member.last_login_at, 30) ? 'stale-login' : ''}>
                                    {toRelativeTimeString(member.last_login_at)}
                                  </span>
                                : <span className="stale-login">{t('user.team_never_signed_in')}</span>}
                            {member.recent_sign_in_count > 0 &&
                            <span className="user-info-email"> · {t('user.team_recent_sign_ins', {count: member.recent_sign_in_count})}</span>}
                        </span>
                    </div>)}
            </div>}
            {(() => {
                const detail = engagementDetails[rowData.id];
                if (!detail || !detail.daily || !detail.daily.length)
                    return null;
                const kinds = ['campaign', 'product', 'competitor_url'];
                const summarise = (bucket) => kinds
                    .filter(kind => bucket[kind])
                    .map(kind => `${bucket[kind]} ${kind}`)
                    .join(', ') || '-';
                return <div className="user-detail-group">
                    <div className="user-detail-title">{t('user.engagement_timeline')}</div>
                    {detail.setup && detail.setup.competitor_hosts.length > 0 &&
                    <div className="user-detail-row">
                        <span className="user-detail-label">{t('user.engagement_tracking')}</span>
                        <span className="user-detail-value">{detail.setup.competitor_hosts.join(', ')}</span>
                    </div>}
                    {detail.daily.map(entry =>
                        <div className="user-detail-row" key={entry.date}>
                            <span className="user-detail-label">{entry.date}</span>
                            <span className="user-detail-value">
                                {t('user.engagement_logins')}: {entry.login} · {t('user.engagement_by_user')}: {summarise(entry.self)} · {t('user.engagement_by_admin')}: {summarise(entry.admin)}
                            </span>
                        </div>)}
                </div>;
            })()}
            <div className="user-detail-group">
                <div className="user-detail-title">{t('user.subscription_details')}</div>
                <div className="user-detail-row">
                    <span className="user-detail-label">{t('subscription.plan')}</span>
                    <span className="user-detail-value">
                        {subscription && subscription.type ? toTitleCase(subscription.type) : '-'}
                        {subscription && subscription.type &&
                        <span className={`user-detail-badge ${subscription.is_paid ? 'paid' : 'unpaid'}`}>
                            {subscription.is_paid ? t('actions.paid') : t('actions.notpaid')}
                        </span>}
                    </span>
                </div>
                {subscription && subscription.finish_at &&
                <div className="user-detail-row">
                    <span className="user-detail-label">{t('subscription.finish_at')}</span>
                    <span className="user-detail-value" title={toDateTimeString(subscription.finish_at)}>
                        {toRelativeTimeString(subscription.finish_at)}
                    </span>
                </div>}
                <div className="user-detail-actions">
                    <Button label={t('actions.subscription_history')} icon="pi pi-briefcase" className="p-button-text p-button-plain p-button-sm" onClick={(e) => showSubscriptionHistory(e, rowData)}/>
                    <Button label={t('actions.special_plan')} icon="pi pi-star" className="p-button-text p-button-plain p-button-sm" onClick={(e) => showSpecialPlan(e, rowData)}/>
                    <Button label={t('actions.charge_user')} icon="pi pi-money-bill" className="p-button-text p-button-plain p-button-sm" onClick={() => showChargingDialog(rowData)}/>
                    <span title={hasActiveSubscription(rowData) ? t('user.start_trial_blocked') : ''}>
                        <Button label={t('actions.start_trial')} icon="pi pi-play" className="p-button-text p-button-plain p-button-sm"
                                disabled={hasActiveSubscription(rowData)} onClick={() => showTrialDialog(rowData)}/>
                    </span>
                </div>
            </div>
            <div className="user-detail-group">
                <div className="user-detail-title">{t('user.status_details')}</div>
                <div className="user-detail-switches">
                    <div className="user-detail-switch">
                        <span className="user-detail-label">{t('user.is_locked')}</span>
                        <InputSwitch checked={rowData.is_locked} onChange={() => changeIsLocked(rowData)} tooltip={rowData.is_locked ? t('actions.unlock') : t('actions.lock')}/>
                    </div>
                    <div className="user-detail-switch">
                        <span className="user-detail-label">{t('user.is_active')}</span>
                        <InputSwitch checked={rowData.is_active} onChange={() => changeIsActive(rowData)} tooltip={rowData.is_active ? t('actions.deactivate') : t('actions.activate')}/>
                    </div>
                    <div className="user-detail-switch">
                        <span className="user-detail-label">{t('user.is_approved')}</span>
                        {rowData.is_approved
                            ? <span className="user-detail-badge paid">{t('actions.approved')}</span>
                            : <InputSwitch checked={rowData.is_approved} onChange={() => changeIsApproved(rowData)} tooltip={t('actions.approve')}/>}
                    </div>
                </div>
                <div className="user-detail-actions">
                    <Button label={t('actions.change_password')} icon="pi pi-key" className="p-button-text p-button-plain p-button-sm" onClick={() => showPasswordDialog(rowData)}/>
                </div>
            </div>
        </div>;
    };

    const rowMenuItems = [
        {
            label: t('actions.delete'),
            icon: 'pi pi-trash',
            command: () => confirmDelete(menuUser)
        }
    ];

    const actionTemplate = (rowData) => {
        return <div className="row-actions">
            <Button icon="pi pi-users" className="p-button-text p-button-plain p-button-rounded" tooltip={t('actions.impersonate')} tooltipOptions={{position: 'bottom'}} onClick={() => impersonate(rowData)}/>
            <Button icon="pi pi-shopping-cart" className="p-button-text p-button-plain p-button-rounded" tooltip={t('actions.update_subscription')} tooltipOptions={{position: 'bottom'}} onClick={() => showSubscriptionDialog(rowData)}/>
            <Button icon="pi pi-pencil" className="p-button-text p-button-plain p-button-rounded" tooltip={t('actions.edit')} tooltipOptions={{position: 'bottom'}} onClick={() => withFullUser(rowData, fullUser => {
                setRowData(fullUser);
                setShowEditModal(true);
            })}/>
            <Button icon="pi pi-ellipsis-v" className="p-button-text p-button-plain p-button-rounded" onClick={(e) => {
                setMenuUser(rowData);
                rowMenu.current.toggle(e);
            }}/>
        </div>;
    };

    let changePasswordFooter = <div className="ui-dialog-buttonpane p-clearfix">
        <Button id="cancel" label={t('actions.cancel')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" onClick={() => setPasswordDialogVisible(false)}/>
        <Button id="add" label={t('actions.change_password')} icon="pi pi-key" className="p-button-outlined p-button-success" onClick={changePassword}/>
    </div>;

    const chargeUserIsTR = dialogUser != null && dialogUser.country === 'TR';
    const chargeInTRY = chargeUserIsTR || chargeCurrency === 'TRY';

    let chargeUserFooter = <div className="ui-dialog-buttonpane p-clearfix">
        {!chargePreview && <React.Fragment>
            <Button id="cancel" label={t('actions.cancel')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" onClick={() => setChargeDialogVisible(false)}/>
            <Button id="preview_charge" label={t('actions.review_charge')} icon="pi pi-search" className="p-button-outlined p-button-success" disabled={chargeLoading || !charge.amount} onClick={previewCharge}/>
        </React.Fragment>}
        {chargePreview && <React.Fragment>
            <Button id="back" label={t('actions.back')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" disabled={chargeLoading} onClick={() => setChargePreview(null)}/>
            <Button id="charge" label={t('actions.charge_user')} icon="pi pi-money-bill" className="p-button-outlined p-button-success" disabled={chargeLoading} onClick={chargeUser}/>
        </React.Fragment>}
    </div>;

    let startTrialFooter = <div className="ui-dialog-buttonpane p-clearfix">
        <Button id="cancel" label={t('actions.cancel')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" onClick={() => setTrialDialogVisible(false)}/>
        <Button id="start_trial" label={t('actions.start_trial')} icon="pi pi-play" className="p-button-outlined p-button-success"
                disabled={trialLoading || !trialDays || trialDays < 1 || trialDays > MAX_TRIAL_DAYS} onClick={startTrial}/>
    </div>;

    let specialPlanFooter = <div className="ui-dialog-buttonpane p-clearfix">
        <Button id="cancel" label={t('actions.cancel')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" onClick={() => setSpecialPlanDialogVisible(false)}/>
        <Button id="delete_special_plan" label={t('actions.delete')} icon="pi pi-trash" className="p-button-outlined p-button-danger" onClick={deleteSpecialPlan}/>
        <Button id="save_special_plan" label={t('actions.save')} icon="pi pi-save" className="p-button-outlined p-button-success" onClick={addSpecialPlan}/>
    </div>;

    const subscriptionFooter = (
        <React.Fragment>
            <div>
                <Button label={t('actions.cancel')} icon="pi pi-angle-double-left" className="p-button-outlined p-button-warning" onClick={() => setSubscriptionDialogVisible(false)}/>
                <Button label={t('actions.save')} icon="pi pi-save" className="p-button-outlined p-button-success" onClick={() => updateSubscription()}/>
            </div>
            <br></br>

            {editedSubscription.type === 'special' &&
            <div>
                <Dropdown name="standardPricingPlans" style={{marginRight:"0.5em"}} value={selectedStandardPricingPlan} options={standardPricingPlans} onChange={(e)=>{setSelectedStandardPricingPlan(getKeyValue(e).value);}}/>
                <Button label={t('actions.convert')} icon="pi pi-angle-double-right" className="p-button-outlined p-button-danger" onClick={() => convertSpecialSubscription()}/>
            </div>}
        </React.Fragment>
    );

    const userUpdateCompleted = (updatedUser) => {
        // Merge: the edited record lacks the list-only fields (subscription,
        // engagement, shopify_shop, connected_integrations).
        const index = users.findIndex(user => user.id === updatedUser.id);
        users[index] = {...users[index], ...updatedUser};
        setUsers([...users]);
        setRowData(null);
        setShowEditModal(false);
        toast.current.show({severity: 'success', summary: t('account.save_account'), detail: t('message_detail.successful')});
    };

    const hasActivePlan = (user, type) => user.subscription && subscriptionPlanKey(user.subscription) === type
        && !user.subscription.is_canceled
        && !(user.subscription.finish_at && Date.parse(user.subscription.finish_at) < new Date());

    const categoryMatchers = {
        'all': () => true,
        'admin': user => user.is_admin,
        'basic': user => hasActivePlan(user, 'basic'),
        'professional': user => hasActivePlan(user, 'professional'),
        'premium': user => hasActivePlan(user, 'premium'),
        'special': user => hasActivePlan(user, 'special'),
        'potential': user => user.tags.includes('Alabilir'),
        'former': user => user.tags.includes('Eski Müşteri'),
        'account-setup': user => user.tags.includes('Hesap Kurulacak'),
        'trial': user => !user.is_admin && user.subscription && user.subscription.type === 'trial' && Date.parse(user.subscription.finish_at) > new Date(),
        'ex-trial': user => user.subscription && user.subscription.type === 'trial' && Date.parse(user.subscription.finish_at) < new Date(),
        'engaged': user => !!(user.engagement && user.engagement.level === 'engaged'),
        'shopify': user => !!user.shopify_shop
    };

    const textFilteredUsers = () => {
        return users.map(user=> ({ ...user, full_name: toTitleCase(user.first_name) + ' ' + toTitleCase(user.last_name) })).filter(
            u=> {
                return Object.keys(u).some((key) => {
                   return typeof u[key] !== 'object' && u[key] && u[key].toString().toLowerCase().includes(filter.toLowerCase());
                })
            }
        );
    };

    const filteredUsers = () => {
        const matcher = categoryMatchers[selectedUserType] || categoryMatchers['all'];
        return textFilteredUsers().filter(matcher);
    };

    const userTypeGroups = [
        [{className: "all", name: "All", value: "all"}],
        [{className: "admin", name: "Admin", value: "admin"}],
        [
            {className: "basic", name: "Basic", value: "basic"},
            {className: "professional", name: "Professional", value: "professional"},
            {className: "premium", name: "Premium", value: "premium"},
            {className: "special", name: "Special", value: "special"}
        ],
        [
            {className: "trial", name: "Trial", value: "trial"},
            {className: "exTrial", name: "Ex-Trial", value: "ex-trial"},
            {className: "engaged", name: "Engaged", value: "engaged"}
        ],
        [
            {className: "potential", name: "Potential", value: "potential"},
            {className: "former", name: "Former", value: "former"},
            {className: "accountSetup", name: "Account Setup", value: "account-setup"}
        ],
        [{className: "shopify", name: "Shopify", value: "shopify"}]
    ];

    const userTypeFilterBar = () => {
        const visibleUsers = textFilteredUsers();
        return <div className="user-type-filter">
            {/* p-input-icon-right is applied only while the clear icon is rendered;
                with both classes and a single icon, the icon is first- AND
                last-of-type, gets left+right offsets and stretches over the
                input, swallowing clicks. */}
            <span className={`p-input-icon-left${filter ? ' p-input-icon-right' : ''} users-search`}>
                <i className="pi pi-search"/>
                <InputText name="filter" value={filter} onChange={(e) => {setFilter(getKeyValue(e).value)}} placeholder={t('product.globalFilter')} />
                {filter && <i className="pi pi-times users-search-clear" onClick={() => setFilter('')}/>}
            </span>
            {userTypeGroups.map((group, groupIndex) =>
                <React.Fragment key={groupIndex}>
                    {groupIndex > 0 && <span className="filter-divider"/>}
                    {group.map(option => {
                        const selected = selectedUserType === option.value;
                        const count = visibleUsers.filter(categoryMatchers[option.value]).length;
                        return <button key={option.value} type="button"
                                       className={`filter-chip${selected ? ` selected ${option.className}` : ''}${count === 0 && !selected ? ' empty' : ''}`}
                                       onClick={() => setSelectedUserType(selected ? 'all' : option.value)}>
                            {option.value === 'shopify'
                                ? <i className="pi pi-shopping-cart" style={{fontSize: '0.85em'}}/>
                                : <span className={`filter-dot ${option.className}`}/>}
                            <span>{option.name}</span>
                            <span className="filter-count">{count}</span>
                        </button>;
                    })}
                </React.Fragment>
            )}
        </div>;
    };

    const additionalFeatureSelectTemplate = (rowData) => {
        return rowData.is_selected ? t('trueFalse.true') : t('trueFalse.false');
    };

    const additionalFeatureNameTemplate = (rowData) => {
        return t('subscription.' + rowData.name);
    };

    const additionalFeatureSelectEditor = (props) => {
        return <Checkbox inputId="is_selected" name="is_selected" value={props.rowData.is_selected} checked={props.rowData.is_selected} onChange={(e)=>{
            let additional_feature = currentPlan.additional_features.filter(additional_feature => additional_feature.name === props.rowData.name)[0]
            additional_feature.is_selected = getKeyValue(e).value;
            props.rowData.is_selected = getKeyValue(e).value;
        }}/>;
    };

    const additionalFeaturePriceEditor = (props) => {
        return <InputNumber value={props.rowData.price} style={{width:"80px"}} mode="decimal" minFractionDigits={2} onValueChange={(e)=>{
            let additional_feature = currentPlan.additional_features.filter(additional_feature => additional_feature.name === props.rowData.name)[0]
            additional_feature.price = getKeyValue(e).value;
        }}/>;
    };

    return (

        <React.Fragment>
            <Dialog visible={subscriptionHistoryDialogVisible} header={dialogHeader(t('actions.subscription_history'))} style={{maxWidth: '70vw', minWidth: '40vw'}} breakpoints={{'960px': '75vw', '640px': '95vw'}} modal={true} onHide={() => setSubscriptionHistoryDialogVisible(false)}>
                <DataTable value={subscriptionHistory} responsive={true}>
                    <Column field="type" header={t('subscription.plan')}  />
                    <Column field="start_at" header={t('subscription.start_at')} />
                    <Column field="finish_at" header={t('subscription.finish_at')} />
                    <Column field="price" header={t('subscription.price')}/>
                    <Column field="billed_amount" header={t('subscription.billed_amount')}/>
                    <Column field="is_paid" header={t('subscription.is_paid')}/>
                    <Column field="is_canceled" header={t('subscription.is_canceled')}/>
                    <Column field="created_at" body={createdAtTemplate} header={t('subscription.created_at')}/>
                </DataTable>
            </Dialog>

            <Dialog visible={specialPlanDialogVisible} header={dialogHeader(t('actions.update_subscription'))} footer={specialPlanFooter} modal={true} onHide={() => setSpecialPlanDialogVisible(false)} >
                {specialPlan && <PricingPlanForm plan={specialPlan}/>}
            </Dialog>

            <Dialog visible={subscriptionDialogVisible} header={dialogHeader(t('actions.update_subscription'))} footer={subscriptionFooter} modal={true} onHide={() => setSubscriptionDialogVisible(false)} >
                <div className="card card-w-title alignCenter p-fluid">
                    <div className="p-grid p-fluid">
                        <div className="p-col-12">
                            <h4>{t('subscription.plan') + " : " + editedSubscription.name}</h4>
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="plan_price">{t('subscription.total_price')}</label>
                            <InputText id="plan_price" name="plan_price" value={editedSubscription.plan_price ?? ""} onChange={onChange}
                                       className={formErrors.plan_price.length > 0 ? "p-error" : null}/>
                            {formErrors.plan_price.length > 0 && (<Message severity="error" text={formErrors.plan_price}/>)}
                        </div>
                        <div className="p-col-6">
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="start_at">{t('subscription.start_at')}</label>
                            <InputText id="start_at" name="start_at" value={editedSubscription.start_at ?? ""} onChange={onChange}
                                       className={formErrors.start_at.length > 0 ? "p-error" : null}/>
                            {formErrors.start_at.length > 0 && (<Message severity="error" text={formErrors.start_at}/>)}
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="finish_at">{t('subscription.finish_at')}</label>
                            <InputText id="finish_at" name="finish_at" value={editedSubscription.finish_at ?? ""} onChange={onChange}
                                       className={formErrors.finish_at.length > 0 ? "p-error" : null}/>
                            {formErrors.finish_at.length > 0 && (<Message severity="error" text={formErrors.finish_at}/>)}
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="total_product_count">{t('subscription.total_product_count')}</label>
                            <InputText id="total_product_count" name="total_product_count" keyfilter="pint" value={editedSubscription.total_product_count ?? ""} onChange={onChange}
                                       className={formErrors.total_product_count.length > 0 ? "p-error" : null}/>
                            {formErrors.total_product_count.length > 0 && (<Message severity="error" text={formErrors.total_product_count}/>)}
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="daily_price_check_count">{t('subscription.daily_price_check_count')}</label>
                            <InputText id="daily_price_check_count" name="daily_price_check_count" keyfilter="pint" value={editedSubscription.daily_price_check_count ?? ""} onChange={onChange}
                                       className={formErrors.daily_price_check_count.length > 0 ? "p-error" : null}/>
                            {formErrors.daily_price_check_count.length > 0 && (<Message severity="error" text={formErrors.daily_price_check_count}/>)}
                        </div>
                        <div className="p-col-6">
                            <label htmlFor="manuel_price_check_count">{t('subscription.manuel_price_check_count')}</label>
                            <InputText id="manuel_price_check_count" name="manuel_price_check_count" keyfilter="pint" value={editedSubscription.manuel_price_check_count ?? ""} onChange={onChange}
                                       className={formErrors.manuel_price_check_count.length > 0 ? "p-error" : null}/>
                            {formErrors.manuel_price_check_count.length > 0 && (<Message severity="error" text={formErrors.manuel_price_check_count}/>)}
                        </div>
                        <div className="p-col-6">
                            <Checkbox id="instant_price_check_enabled" name="instant_price_check_enabled" value={editedSubscription.instant_price_check_enabled} checked={editedSubscription.instant_price_check_enabled === true} onChange={onChange}/>
                            <label htmlFor="instant_price_check_enabled">{t('subscription.instant_price_check_enabled')}</label>
                        </div>
                        <div className="p-col-6">
                            <Checkbox id="sale_history_enabled" name="sale_history_enabled" value={editedSubscription.sale_history_enabled} checked={editedSubscription.sale_history_enabled === true} onChange={onChange}/>
                            <label htmlFor="sale_history_enabled">{t('subscription.sale_history_enabled')}</label>
                        </div>
                        <div className="p-col-6">
                            <Checkbox id="competitor_suggestion_enabled" name="competitor_suggestion_enabled" value={editedSubscription.competitor_suggestion_enabled} checked={editedSubscription.competitor_suggestion_enabled === true} onChange={onChange}/>
                            <label htmlFor="competitor_suggestion_enabled">{t('subscription.competitor_suggestion_enabled')}</label>
                        </div>
                        <div className="p-col-6">
                            <Checkbox id="dynamic_pricing_enabled" name="dynamic_pricing_enabled" value={editedSubscription.dynamic_pricing_enabled} checked={editedSubscription.dynamic_pricing_enabled === true} onChange={onChange}/>
                            <label htmlFor="dynamic_pricing_enabled">{t('subscription.dynamic_pricing_enabled')}</label>
                        </div>
                        <div className="p-col-6">
                            <Checkbox id="is_paid" name="is_paid" value={editedSubscription.is_paid} checked={editedSubscription.is_paid === true} onChange={onChange}/>
                            <label htmlFor="is_paid">{t('subscription.is_paid')}</label>
                        </div>
                        <div className="p-col-6">
                            <Checkbox id="is_canceled" name="is_canceled" value={editedSubscription.is_canceled} checked={editedSubscription.is_canceled === true} onChange={onChange}/>
                            <label htmlFor="is_canceled">{t('subscription.is_canceled')}</label>
                        </div>
                        {/* Bank transfer: the transfer for the following period has arrived. Hides the
                            customer's renewal reminder for this period. */}
                        <div className="p-col-6">
                            <Checkbox id="payment_confirmed" checked={!!editedSubscription.payment_confirmed_at}
                                      onChange={(e) => setEditedSubscription({...editedSubscription, payment_confirmed_at: e.checked ? new Date().toISOString() : null})}/>
                            <label htmlFor="payment_confirmed">{t('subscription.payment_confirmed')}</label>
                        </div>
                        {editedSubscription.payment_reported_at &&
                        <div className="p-col-6" style={{color: '#b45309'}}>
                            {t('subscription.payment_reported_at')}: {toDateTimeString(editedSubscription.payment_reported_at)}
                        </div>}
                        <div className="p-col-12">
                            {currentPlan &&
                            <DataTable value={currentPlan.additional_features}>
                                <Column field="is_selected" header={t('table_headers.is_selected')} body={additionalFeatureSelectTemplate} editor={additionalFeatureSelectEditor}/>
                                <Column field="name" header={t('table_headers.name')} body={additionalFeatureNameTemplate}/>
                                <Column field="price" header={t('subscription.price')} editor={additionalFeaturePriceEditor}/>
                            </DataTable>
                            }
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={passwordDialogVisible} header={dialogHeader(t('actions.change_password'))} footer={changePasswordFooter} modal={true} onHide={() => setPasswordDialogVisible(false)}>
                <div className="p-grid alignCenter p-fluid">
                    <div className="p-col-12">
                        <span className="p-float-label">
                            <Password id="new_password" name="new_password" value={change_password.new_password} onChange={onChange}
                                      autoComplete="new-password"
                                      className={formErrors.new_password.length > 0 ? "p-error" : null}/>
                            <label htmlFor="new_password">{t('user.new_password')}</label>
                        </span>
                        {formErrors.new_password.length > 0 && (<Message severity="error" text={formErrors.new_password}/>)}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={trialDialogVisible} header={dialogHeader(t('actions.start_trial'))} footer={startTrialFooter} modal={true} onHide={() => setTrialDialogVisible(false)}>
                <div className="p-grid alignCenter p-fluid">
                    <div className="p-col-12">
                        <Message severity="info" text={t('user.start_trial_info', {email: dialogUser ? dialogUser.email : ''})}/>
                    </div>
                    <div className="p-col-12">
                        <span className="p-float-label">
                            <InputNumber id="trial_days" value={trialDays} style={{width: "200px"}} min={1} max={MAX_TRIAL_DAYS}
                                         showButtons onValueChange={(e) => setTrialDays(e.value)}/>
                            <label htmlFor="trial_days">{t('user.trial_days')}</label>
                        </span>
                        {trialDays > 0 && <small>{t('user.trial_finish_at', {date: trialFinishDate(trialDays)})}</small>}
                    </div>
                </div>
            </Dialog>

            <Dialog visible={chargeDialogVisible} header={dialogHeader(t('actions.charge_user'))} footer={chargeUserFooter} modal={true} onHide={() => {setChargeDialogVisible(false); setChargePreview(null);}}>
                {!chargePreview &&
                <div className="p-grid alignCenter p-fluid">
                    {chargeCurrency &&
                    <div className="p-col-12">
                        <Tag value={chargeCurrency === 'TRY' ? t('user.charge_currency_try') : t('user.charge_currency_usd')}
                             severity={chargeCurrency === 'TRY' ? 'info' : 'success'} icon="pi pi-money-bill"/>
                    </div>}
                    <div className="p-col-12">
                        <Message severity="info" text={t('actions.payment_message')} />
                    </div>
                    <div className="p-col-12">
                        <span className="p-float-label">
                              <InputNumber id="amount" name="amount" value={charge.amount} style={{width:"200px"}}
                                           mode="decimal" minFractionDigits={2}
                                           onValueChange={onChange}/>
                              <label htmlFor="amount">{t('user.charge_amount')}</label>
                        </span>
                    </div>
                    <div className="p-col-12">
                        <span className="p-float-label">
                              <InputNumber id="vat_rate" name="vat_rate" value={charge.vat_rate} style={{width:"200px"}}
                                           mode="decimal" minFractionDigits={0} maxFractionDigits={2} suffix="%"
                                           readOnly={!chargeUserIsTR}
                                           onValueChange={onChange}/>
                              <label htmlFor="vat_rate">{t('user.vat_rate')}</label>
                        </span>
                    </div>
                    <div className="p-col-12">
                        <span className="p-float-label">
                              <InputNumber id="exchange_rate" name="exchange_rate" value={charge.exchange_rate} style={{width:"200px"}}
                                           mode="decimal" minFractionDigits={2} maxFractionDigits={4}
                                           readOnly={!chargeInTRY}
                                           onValueChange={onChange}/>
                              <label htmlFor="exchange_rate">{t('user.exchange_rate')}</label>
                        </span>
                        <small>{chargeUserIsTR ? t('user.exchange_rate_hint')
                            : (chargeCurrency === 'TRY' ? t('user.exchange_rate_amex_hint') : t('user.vat_exchange_tr_only_hint'))}</small>
                    </div>
                </div>}
                {chargePreview &&
                <div className="p-grid p-fluid">
                    <div className="p-col-12">
                        <Message severity="warn" text={t('user.charge_confirm_message')} />
                    </div>
                    <div className="p-col-12">
                        <table style={{width: "100%", borderCollapse: "collapse"}}>
                            <tbody>
                            <tr>
                                <td style={{padding: "0.4rem 0"}}>{t('user.charge_amount_excl_vat')}</td>
                                <td style={{padding: "0.4rem 0", textAlign: "right"}}>
                                    {chargePreview.amount.toFixed(2)} USD
                                    {chargePreview.currency === 'TRY' && ` (${(chargePreview.amount * chargePreview.exchange_rate).toFixed(2)} TRY)`}
                                </td>
                            </tr>
                            <tr>
                                <td style={{padding: "0.4rem 0"}}>{t('user.charge_vat_amount', {rate: chargePreview.vat_rate})}</td>
                                <td style={{padding: "0.4rem 0", textAlign: "right"}}>
                                    {chargePreview.vat_amount.toFixed(2)} USD
                                    {chargePreview.currency === 'TRY' && ` (${chargePreview.charged_vat_amount.toFixed(2)} TRY)`}
                                </td>
                            </tr>
                            <tr>
                                <td style={{padding: "0.4rem 0"}}>{t('user.charge_total_amount')}</td>
                                <td style={{padding: "0.4rem 0", textAlign: "right"}}>
                                    {chargePreview.total_amount.toFixed(2)} USD
                                    {chargePreview.currency === 'TRY' && ` (${chargePreview.charged_total.toFixed(2)} TRY)`}
                                </td>
                            </tr>
                            {chargePreview.currency === 'TRY' &&
                            <tr>
                                <td style={{padding: "0.4rem 0"}}>{t('user.exchange_rate')}</td>
                                <td style={{padding: "0.4rem 0", textAlign: "right"}}>
                                    {chargePreview.exchange_rate}
                                    {charge.exchange_rate === null && ` (${t('user.instant_rate')})`}
                                </td>
                            </tr>}
                            <tr style={{borderTop: "1px solid #dee2e6"}}>
                                <td style={{padding: "0.4rem 0"}}><b>{t('user.charge_total_to_charge')}</b></td>
                                <td style={{padding: "0.4rem 0", textAlign: "right"}}><b>{chargePreview.charged_total.toFixed(2)} {chargePreview.currency}</b></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="p-col-12" style={{display: "flex", justifyContent: "center", paddingTop: "0.5rem"}}>
                        <div style={{position: "relative", width: "56px", height: "56px"}}>
                            <svg width="56" height="56" viewBox="0 0 56 56" style={{transform: "rotate(-90deg)"}}>
                                <circle cx="28" cy="28" r={CHARGE_COUNTDOWN_RADIUS} fill="none" stroke="#e3f2fd" strokeWidth="4"/>
                                <circle cx="28" cy="28" r={CHARGE_COUNTDOWN_RADIUS} fill="none" stroke="#2196F3" strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeDasharray={CHARGE_COUNTDOWN_CIRCUMFERENCE}
                                        strokeDashoffset={CHARGE_COUNTDOWN_CIRCUMFERENCE * (1 - (chargePreviewSecondsLeft ?? CHARGE_PREVIEW_TTL_SECONDS) / CHARGE_PREVIEW_TTL_SECONDS)}
                                        style={{transition: "stroke-dashoffset 1s linear"}}/>
                            </svg>
                            <span style={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                                          color: "#2196F3", fontWeight: "bold", fontSize: "1.1rem"}}>
                                {chargePreviewSecondsLeft ?? CHARGE_PREVIEW_TTL_SECONDS}
                            </span>
                        </div>
                    </div>
                </div>}
            </Dialog>

            <div className="card management-page users-page">
                <Menu model={rowMenuItems} popup ref={rowMenu}/>
                <OverlayPanel ref={tagsPanel} dismissable={true}>
                    {tagsUser && <div className="tags-editor">
                        {tagList.map(tag =>
                            <div key={tag} className="tags-editor-item">
                                <Checkbox inputId={`tag_option_${tag}`} checked={tagsUser.tags.includes(tag)}
                                          onChange={(e) => toggleTag(tag, e.checked)}/>
                                <label htmlFor={`tag_option_${tag}`}>{tag}</label>
                            </div>
                        )}
                    </div>}
                </OverlayPanel>
                <div className="users-sticky-header" ref={stickyHeaderRef}>
                    <AdminPageHeader
                        title={t('menu_item.users')}
                        subtitle={t('menu.management_hub.page.user')}
                        actions={<>
                            <Button icon={refreshing ? "pi pi-spin pi-refresh" : "pi pi-refresh"} data-tour="step5" tooltip={t('actions.refresh')}
                                    tooltipOptions={{position: 'bottom'}} className="p-button-text p-button-plain"
                                    disabled={refreshing}
                                    onClick={() => {setForceRefresh(forceRefresh + 1);}}/>
                            <Button icon="pi pi-eye" data-tour="step5" tooltip={t('user.all_users')}
                                    tooltipOptions={{position: 'bottom'}} className="p-button-text p-button-plain"
                                    onClick={() => {getUsers(true);}}/>
                            <Button icon={resolvingCountries ? "pi pi-spin pi-spinner" : "pi pi-globe"}
                                    tooltip={t('actions.resolve_signup_countries')}
                                    tooltipOptions={{position: 'bottom'}} className="p-button-text p-button-plain"
                                    disabled={resolvingCountries}
                                    onClick={resolveSignupCountries}/>
                        </>}
                    />
                    {userTypeFilterBar()}
                </div>

                {loading ? <div className="p-col-12" style={{textAlign:'center'}}>
                    <Loading/>
                </div> :
                <div className="p-col-12">
                    <DataTable ref={dtUsers} value={filteredUsers()}
                               responsive={true}
                               paginator={true}
                               rows={50}
                               paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                               currentPageReportTemplate="{first} - {last} / {totalRecords}"
                               sortField="last_login_at" sortOrder={-1}
                               style={{fontSize:'0.9em'}}
                               dataKey="id"
                               rowExpansionTemplate={detailTemplate}
                               expandedRows={expandedRows}
                               onRowToggle={(e) => {
                                   // e.data is an id-keyed object only because
                                   // the table sets dataKey="id"; without it
                                   // PrimeReact passes an array of rows.
                                   setExpandedRows(e.data);
                                   Object.keys(e.data || {}).forEach(userId => {
                                       if (engagementDetails[userId] === undefined) {
                                           setEngagementDetails(prev => ({...prev, [userId]: null}));
                                           userService.getEngagement(userId)
                                               .then(detail => setEngagementDetails(prev => ({...prev, [userId]: detail})))
                                               .catch(() => setEngagementDetails(prev => ({...prev, [userId]: null})));
                                       }
                                   });
                               }}>
                        <Column expander={true} style={{width:"3em"}} />
                        <Column field="tags" header={t('user.tags')} body={tagsTemplate} style={{width:"13rem"}}/>
                        <Column field="full_name" header={t('user.name')} body={userInfoTemplate} style={{width:"18rem"}}/>
                        <Column field="last_login_at" header={t('user.last_login')} body={last_login_atTemplate} sortable={true} style={{width:"9rem"}}/>
                        <Column field="note" header={t('user.note')} body={noteTemplate}/>
                        <Column field="connected_integrations" header={t('user.integrations')} body={integrationsTemplate} style={{width:"11rem"}}/>
                        <Column body={actionTemplate} className="p-align-center" style={{width:"11rem"}}/>
                    </DataTable>
                </div>}

                {showEditModal && <UpdateUser selectedUser={rowData} userUpdateCompleted={userUpdateCompleted} hideDialog={() => {setShowEditModal(false)}}  />}

                {notesUser && <UserNotes user={notesUser} hideDialog={() => setNotesUser(null)} onNotesChanged={notesChanged}/>}

                {integrationsUser &&
                <Dialog header={`${t('user.integrations')} — ${userDisplayName(integrationsUser)}`} visible={true}
                        style={{width: '44rem', maxWidth: '95vw'}} modal={true}
                        onHide={() => setIntegrationsUser(null)}>
                    <UserIntegrations user={integrationsUser} onPersist={persistIntegrations}/>
                </Dialog>}

            </div>
        </React.Fragment>
    );
};

export default User;
